<template>
  <div :class="['modal', 'modal-fx-fadeInScale', { 'is-active': is_open }]">
    <div class="modal-background"></div>
    <div class="modal-content">
      <p class="is-black title is-4 is-hidden-desktop" v-if="!successfulForm">
        <b>Request a FREE pass from {{ selected_gym.gym_name }}</b>
      </p>
      <div class="modal-card-head is-hidden-touch" v-if="!successfulForm">
        <p class="is-black title is-4">
          <b>Request a FREE pass from {{ selected_gym.gym_name }}</b>
        </p>
      </div>
      <ValidationObserver ref="freePassForm" v-if="!successfulForm">
        <form @submit.prevent="submit" @keyup.enter="submit">
          <ValidationProvider
            name="Name"
            rules="required"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Name"
              left_icon="fa-user"
              :classes="classes"
              :valid="valid"
              placeholder="Name"
              v-model="form.name"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="Email"
            rules="required|email|"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Email"
              left_icon="fa-envelope"
              :classes="classes"
              :valid="valid"
              placeholder="Email"
              v-model="form.email"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="Phone number"
            :rules="{
              required: true,
              regex: /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
            }"
            v-slot="{ classes, errors, valid }"
          >
            <InputSimpleTextVertical
              label="Phone number"
              left_icon="fa-phone"
              :classes="classes"
              :valid="valid"
              placeholder="Phone Number"
              v-model="form.phone_number"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider name="Message" v-slot="{ classes, errors }">
            <InputTextArea
              label="Got something to say? (optional)"
              v-model="form.comment"
            />
            <p class="help">{{ errors[0] }}</p>
          </ValidationProvider>
        </form>
        <div class="modal-card-foot is-hidden-touch">
          <button
            type="submit"
            class="button search-button is-medium"
            @click="submit()"
          >
            Submit
          </button>
          <button
            class="button cancel-button is-medium"
            @click="freeFormPassSwitch()"
          >
            Cancel
          </button>
        </div>
        <div class="is-hidden-desktop">
          <button
            type="submit"
            class="button search-button is-medium"
            @click="submit()"
          >
            Submit
          </button>
          <button
            class="button cancel-button is-medium"
            @click="freeFormPassSwitch()"
          >
            Cancel
          </button>
        </div>
        <h3 class="errorMessage">{{ errorMessage || "" }}</h3>
      </ValidationObserver>
      <div v-else class="modal-content mb-4">
        <sweetalert-icon icon="success" color="#00c5fd"></sweetalert-icon>
        <h2 class="title is-4 has-text-centered">Message Submitted</h2>
        <h2 class="subtitle is-4 has-text-centered">
          {{ selected_gym.gym_name }} will contact you shortly.
        </h2>
        <h2 class="subtitle is-4 has-text-centered">Enjoy your workout!</h2>
      </div>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="freeFormPassSwitch()"
    ></button>
  </div>
</template>

<script>
import InputSimpleTextVertical from "@/components/atoms/InputSimpleTextVertical.vue";
import InputTextArea from "@/components/atoms/InputTextArea.vue";
import SweetalertIcon from "vue-sweetalert-icons";
export default {
  components: {
    InputSimpleTextVertical,
    InputTextArea,
    SweetalertIcon,
  },
  computed: {
    is_open() {
      return this.$store.state.free_pass_form_open;
    },
    selected_gym() {
      return this.$store.state.selected_free_pass_gym;
    },
  },
  data() {
    return {
      form: {
        name: "",
        phone_number: "",
        email: "",
        comment: "",
      },
      successfulForm: false,
      errorMessage: undefined,
    };
  },
  methods: {
    freeFormPassSwitch() {
      this.successfulForm = false;
      this.$store.commit("freeFormPassSwitch");
    },
    async submit() {
      const isValid = await this.$refs.freePassForm.validate();
      if (isValid) {
        try {
          let response = await this.$http.post(
                `/api/referrals/freePass/request`,
                { ...this.form, gym_id: this.selected_gym.gym_id }
              );
          if (response.status === 200) {
            this.successfulForm = true;
            this.form = {
              name: "",
              phone_number: "",
              email: "",
              comment: "",
            };
          } else this.errorMessage = 'Request not sent. Please try again later.'
        } catch (error) {
          console.log(error);
          this.errorMessage = "Request not sent. Please try again later.";
        }
      }
    },
  },
  watch: {
    is_open() {
      if (this.is_open) {
        document.documentElement.style.overflow = "hidden";
        return;
      }
      document.documentElement.style.overflow = "auto";
    },
  },
};
</script>

<style scoped>
button {
  margin: 0.5rem;
}

.errorMessage {
  font-size: 1rem;
  color: red;
}

.cancel-button {
  background-color: lightgray;
  width: 7rem;
}

.help {
  color: red;
  margin-left: 0.5rem;
}

.cancel-button:hover {
  opacity: 0.7;
}

.is-black {
  color: black;
}

.modal-content {
  max-height: calc(100vh - 100px);
  max-width: 95%;
  padding: 0.25rem;
  background: white;
  border-radius: 16px;
}

.modal-card-head {
  padding: 1rem 0.5rem;
}

.modal-card-foot {
  padding: 0.5rem 0 !important;
}

@media (max-width: 768px) {
  .modal-background {
    background: white !important;
    overflow: hidden;
  }
  .modal-close {
    top: 5px;
    right: 5px;
  }
  .modal-close::before,
  .modal-close::after {
    background-color: #00c5fd !important;
  }
  .title {
    margin-left: 0.5rem;
    margin-top: 0.5rem;
  }
}
</style>